import { useEffect, useRef, useState } from 'react';

const useHook = () => {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [stickyTop, setStickyTop] = useState(20);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  const toggleCollapsed = () => setCollapsed(prev => !prev);

  // el navbar es sticky y su altura varía (1 o 2 filas); la sidebar debe
  // engancharse justo debajo, no a un top fijo, o queda tapada al scrollear
  useEffect(() => {
    const measure = () => {
      const header = document.querySelector('header');
      if (header) setStickyTop(header.getBoundingClientRect().height + 20);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const openDrawer = () => setDrawerOpen(true);

  const closeDrawer = () => {
    setOpen(false);
    setTimeout(() => setDrawerOpen(false), 300);
  };

  useEffect(() => {
    if (!drawerOpen) return;

    const openId = setTimeout(() => setOpen(true), 20);
    const focusId = setTimeout(() => closeButtonRef.current?.focus(), 50);
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeDrawer();
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      clearTimeout(openId);
      clearTimeout(focusId);
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  return {
    drawerOpen,
    open,
    closeButtonRef,
    openDrawer,
    closeDrawer,
    collapsed,
    toggleCollapsed,
    stickyTop,
  };
};

export default useHook;
